import styled from '@emotion/styled';
import { Modal as BaseModal } from '@mui/base/Modal';
import rem from '../../utils/rem/rem';
import { ModalStyledProps } from './Modal.types';

export const StyledModal = styled(BaseModal)`
  height: 100vh;
  width: 100vw;
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 110px 0;

  @media ${({ theme }) => theme.breakpoints.sm} {
    align-items: center;
    padding: 0;
  }
`;

export const Overlay = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
`;

export const ModalBody = styled.div<ModalStyledProps>`
  position: relative;
  z-index: 100;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.3);
  width: ${({ width }) => rem(width ?? 656)};
  max-height: calc(100vh - 200px);
  box-sizing: border-box;
  height: min-content;
  overflow: hidden;

  @media (max-width: 680px) {
    width: 100%;
    margin: 0 ${rem(16)};
  }

  @media ${({ theme }) => theme.breakpoints.sm} {
    max-width: ${rem(448)};
  }
`;

export const Title = styled.h1`
  font-family: 'Open Sans';
  font-weight: 700;
  font-size: ${rem(24)};
  line-height: 1.2;
  color: ${({ theme }) => theme.colors.gray900};
  margin: ${rem(32)} ${rem(32)} ${rem(24)} ${rem(32)};

  @media ${({ theme }) => theme.breakpoints.sm} {
    margin: ${rem(24)} ${rem(16)} ${rem(16)} ${rem(16)};
  }
`;

export const ChildrenContainer = styled.div`
  overflow: auto;
  height: 100%;
  max-height: calc(100vh - 280px);
  box-sizing: border-box;

  padding: 0 ${rem(32)} ${rem(32)} ${rem(32)};

  @media ${({ theme }) => theme.breakpoints.sm} {
    padding: 0 ${rem(16)} ${rem(16)} ${rem(16)};
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  top: ${rem(8)};
  right: ${rem(8)};
  border: none;
  background-color: transparent;
  cursor: pointer;
  font-size: ${rem(28)};
  width: ${rem(44)};
  height: ${rem(44)};
  color: ${({ theme }) => theme.colors.gray600};

  &:focus-visible {
    outline: none;
  }
  &:focus-visible svg {
    ${({ theme }) => theme.states.focus};
  }
`;
